import React, { Component } from 'react';
import InfoCommon from './infoCommon';

class InfoTable extends Component {
    state = {
        rowSanpNum: 3,
    };
    render() {
        console.log("InfoTable:"+this.props);
        return (
            <table>
                <colgroup>
                    <col width="26%" />
                    <col width="24%" />
                    <col width="50%" />
                </colgroup>
                <tbody>
                    <InfoCommon Sitnum={this.props.Sitnum} mb_id = {this.props.mb_id} mb_name={this.props.mb_name} test_sec={this.props.test_sec} test_name={this.props.test_name} rowSanpNum={this.state.rowSanpNum} />
                    <tr>
                        <th className="title">교시인증번호</th>
                        <td className="input-area">
                            <div>
                                <input type="text" placeholder="교시인증번호 4자리를 입력해 주세요." className="w-100" onChange={this.props.onExamcode} />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th className="title">생년월일</th>
                        <td className="input-area">
                            <div><input type="text" placeholder="생년월일 6자리를 입력해 주세요." className="w-100" onChange={this.props.onBirthdate}/></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export default InfoTable;